import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'components/base'

export const SUGGESTION_FOR = {
  enableApp: 'enableApp',
  appAssociation: 'appAssociation',
}

export default class IntegrationSuggestion extends PureComponent {
  static propTypes = {
    for: PropTypes.oneOf(Object.keys(SUGGESTION_FOR)),
    name: PropTypes.string.isRequired,
    iconURL: PropTypes.string.isRequired,
    clientId: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onEnableApp: PropTypes.func.isRequired,
    onConnectApp: PropTypes.func.isRequired,
    onSuppress: PropTypes.func,
  }

  render() {
    return (
      <div
        contentEditable={false}
        className="transition margin-top-medium padding-medium radius-normal shadow-hovering"
        style={{ boxShadow: this.props.focused ? '0 0 0 2px #71d1dc' : null }}
      >
        <div className="flexbox">
          {this.props.iconURL && (
            <div className="margin-right-normal">
              <img
                src={this.props.iconURL}
                alt="application-icon"
                style={{ width: 12, height: 12 }}
              />
            </div>
          )}

          <div className="shade-05 font-weight-medium margin-bottom-smaller font-size-large ellipsis">
            {this.renderTitle()}
          </div>
        </div>

        <div className="margin-bottom-medium shade-05 font-size-normal line-height-larger">
          {this.renderBody()}
        </div>

        <div className="flexbox">
          <Button.Primary
            slim
            style={{ minWidth: 'initial' }}
            onClick={() => {
              if (this.props.for === SUGGESTION_FOR.enableApp) {
                return this.props.onEnableApp({ clientId: this.props.clientId })
              }

              return this.props.onConnectApp({ clientId: this.props.clientId })
            }}
          >
            {this.renderFollowContent()}
          </Button.Primary>

          <Button.Secondary
            slim
            className="margin-horizontal-normal"
            style={{ minWidth: 'initial' }}
            onClick={() =>
              this.props.onClose({ clientId: this.props.clientId })
            }
          >
            Not now
          </Button.Secondary>
          {/* <Button.Secondary
            slim
            style={{
              border: 'none',
              minWidth: 'initial',
              paddingLeft: 0,
              paddingRight: 0,
            }}
            onClick={() =>
              this.props.onSuppress({ clientId: this.props.clientId })
            }
          >
            Never
          </Button.Secondary> */}
        </div>
      </div>
    )
  }

  renderTitle() {
    switch (this.props.for) {
      case SUGGESTION_FOR.enableApp: {
        return `Enable ${this.props.name} in Slite`
      }
      case SUGGESTION_FOR.appAssociation: {
        return `Connect your ${this.props.name} to Slite`
      }
      default: {
        // this is a bug and should never happen + propTypes are in place so let's make it visible
        throw new Error(`Unknown 'suggestionFor' value: ${this.props.for}`)
      }
    }
  }

  renderBody() {
    switch (this.props.for) {
      case SUGGESTION_FOR.enableApp: {
        return `It looks like a ${
          this.props.name
        } link. By enabling the app you’ll be able to preview your content in real-time`
      }
      case SUGGESTION_FOR.appAssociation: {
        return `It looks like a ${
          this.props.name
        } link. By connecting your account you’ll be able to preview your content in real-time`
      }
      default: {
        // this is a bug and should never happen + propTypes are in place so let's make it visible
        throw new Error(`Unknown 'suggestionFor' value: ${this.props.for}`)
      }
    }
  }

  renderFollowContent() {
    switch (this.props.for) {
      case SUGGESTION_FOR.enableApp: {
        return `Enable`
      }

      case SUGGESTION_FOR.appAssociation: {
        return `Connect`
      }

      default: {
        // this is a bug and should never happen + propTypes are in place so let's make it visible
        throw new Error(`Unknown 'suggestionFor' value: ${this.props.for}`)
      }
    }
  }
}
